import classNames from 'classnames';
import { getBackgroundClassFromSubTheme } from './constants';
import { pageApi, themeApi } from '../../../api/service';
import { BackgroundThemeRevision } from 'referral-types';
import { useMediaOverride } from '../../../hooks/useMediaOverride';

export const CustomMediaBackground = (props: {
  themeRevision?: Partial<BackgroundThemeRevision>;
  themeId?: string;
  pageId?: string;
  isEditing?: boolean;
  mediaOverride?: File | null;
}) => {
  const { themeRevision } = props;
  const subTheme = themeRevision?.subTheme;
  const backgroundClass = getBackgroundClassFromSubTheme(subTheme);

  const { style, videoSrc } = useMediaOverride({
    mediaOverride: props.mediaOverride,
    pageId: props.pageId,
    themeId: props.themeId,
    themeRevision: props.themeRevision,
    isEditing: props.isEditing,
    getOverrideSrc: pageApi.getBackgroundImageSrc,
    getPresetSrc: themeApi.getBackgroundThemePresetSrc,
  });

  return (
    <div className={classNames(backgroundClass, 'relative -z-10 h-full w-full')}>
      {videoSrc ? (
        <video className="h-full w-full object-cover" src={videoSrc} autoPlay loop muted playsInline />
      ) : (
        <div id="custom-media-background" className="h-full w-full" style={style} />
      )}
    </div>
  );
};
